import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class FormCustomValidator {
  static customValidate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return null
    }
  }
}